const AX_INSTRUCTIONS_STEPS = {
    DETAILS_FORM: 'DETAILS_FORM',
    INSTRUCTIONS_WITH_PIN: 'INSTRUCTIONS_WITH_PIN',
    PROCTORING_SETUP: 'PROCTORING_SETUP',
    KALVIUM_HONOUR_CODE: 'KALVIUM_HONOUR_CODE',
    INSTRUCTIONS: 'INSTRUCTIONS',
    SETUP_TEST_ENVIRONMENT: 'SETUP_TEST_ENVIRONMENT',
}

export default AX_INSTRUCTIONS_STEPS
